<template>
  <div class="completed-questions-card-wrapper">
    <section class="completed-questions-card">
      <div class="completed-questions-card__content">
        <div class="completed-questions-card__icon">
          ✓
        </div>
        <h2 class="completed-questions-card__title">
          {{ $t('app.assessment_mode.text.input.all_questions_complete') }}
        </h2>
        <p class="completed-questions-card__message">
          {{ $t('app.assessment_mode.text.input.all_questions_complete_message') }}
        </p>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CompletedQuestionsCard',
});
</script>
